import { Button as UiKitButton } from "@/components/ui-kit/button"
import { CheckCheck } from "lucide-react"

import {
  SherpaDialogDescription,
  SherpaDialogFooter,
  SherpaDialogHeader,
  SherpaDialogTitle,
} from "@/components/ui-kit/dialog"
import { cn } from "@/lib/utils"

export type ContractsDialogSuccessProps = {
  title: React.ReactNode
  description: React.ReactNode
  buttonLabel?: string
  iconWrapperClassName?: string
  onClose: () => void
}

export function ContractsDialogSuccess({
  title,
  description,
  buttonLabel = "Хорошо, спасибо",
  iconWrapperClassName,
  onClose,
}: ContractsDialogSuccessProps) {
  return (
    <>
      <div className={cn("flex justify-center pt-[40px] mb-6 sm:mb-8", iconWrapperClassName)}>
        <CheckCheck size={80} className="size-20 text-brand" />
      </div>
      <SherpaDialogHeader className=" mb-8 sm:mb-[87px]">
        <SherpaDialogTitle className="text-center w-full block max-w-auto text-[28px] leading-[36px] sm:text-[48px] sm:leading-[52px] whitespace-pre-line">{title}</SherpaDialogTitle>
        <SherpaDialogDescription className="grow text-center sm:whitespace-pre-line">
          {description}
        </SherpaDialogDescription>
      </SherpaDialogHeader>
      <SherpaDialogFooter className="flex-col gap-4 sm:flex-col sm:justify-start pt-[10px]">
        <UiKitButton type="button" className="h-[60px] w-full" onClick={onClose}>
          {buttonLabel}
        </UiKitButton>
      </SherpaDialogFooter>
    </>
  )
}
